<template>
  <div id="map" class="h-full w-full" />
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { onMounted } from "vue";

export default {
  name: "MapSearchMap",

  setup(props,context) {
    onMounted(() => {

      mapboxgl.accessToken =
        "pk.eyJ1Ijoia2VyaWdhbiIsImEiOiJjbDNibXIyNDIwMHpvM2NzODN5d2VyMXBuIn0.3472Pt3eUAPbaD7o16V2KQ";

      const map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/kerigan/cl3epvsjb001l14s6560pnk09",
        center: [props.long, props.lat], // starting position [lng, lat]
        zoom: props.zoom, // starting zoom
        attributionControl: false,
      });

      const nav = new mapboxgl.NavigationControl({
          visualizePitch: true
      });
      map.addControl(nav, 'bottom-right');

      map.on('load', () => {

        map.addSource('listings', {
          type: 'geojson',
          data: props.geojson
        })

        map.addLayer({
          'id': 'listings-icon-layer',
          'type': 'circle',
          'source': 'listings',
          'paint': {
            'circle-radius': props.showAreas ? 10 : 10,
            'circle-stroke-width': 3,
            'circle-color': '#4C98DE', //4C98DE
            'circle-stroke-color': '#FFFFFF',
            'circle-stroke-opacity': 1
          },
        })

        map.addLayer({
          'id': 'listings-label-layer',
          'type': 'symbol',
          'source': 'listings',
          'layout': {
            'text-field': props.showAreas ? "{title}" : "{price}",
            'text-padding': 10,
            'text-transform': "uppercase",
            'text-allow-overlap': true,
            'text-size': props.showAreas ? 18 : 12,
            'text-font': ["Roboto Condensed Bold"],
            'text-max-width': 7,
            'text-line-height': 1,
            'text-offset': props.showAreas ? [0, -1] : [0,0]
          },
          'paint': {
            'text-color': '#FFFFFF', //1A344D
            'text-halo-color': '#1A344D', //4C98DE
            'text-halo-width': 2,
            'text-halo-blur': .5
          }
        })

        var bounds = new mapboxgl.LngLatBounds();
        props.geojson.features.forEach(function(feature) {
          bounds.extend(feature.geometry.coordinates);
        });
        map.fitBounds(bounds);


        map.on('click', 'listings-label-layer', (e) => {
          const features = map.queryRenderedFeatures(e.point, {
            layers: ['listings-label-layer']
          })

          if(props.showAreas){
            context.emit('areaclicked', { region: features[0].properties.name })
            dataLayer.push({
              'event': 'user_action',
              'action_name': 'Map Area Click',
              'area': features[0].properties.name,
            })

          } else {
            context.emit('listingclicked', { mls: features[0].properties.mls })
            dataLayer.push({
              'event': 'user_action',
              'action_name': 'Map Listing Click',
              'mls_account': features[0].properties.mls,
            })

          }

        })

      })

    })

    return {}
  },

  props: {
    lat: {
      type: Number,
      default: 0,
    },
    long: {
      type: Number,
      default: 0,
    },
    zoom: {
      type: Number,
      default: 10,
    },
    geojson: {
      type: Object,
      default: () => {},
    },
    showAreas: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      accessToken: "pk.eyJ1Ijoia2VyaWdhbiIsImEiOiJjazgwOHVuNjYwZWJhM2xucXZpYzh3bGhwIn0.PZrI3RoUM7a7EWb1JUm5nA", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/kerigan/cl3epvsjb001l14s6560pnk09", // your map style
      coordinates: [this.long,this.lat],
      map: null,
      host: ''
    }
  },
}
</script>
